/**
 * Select the workspace to render without conflating an approval capability
 * with an organization's primary admin role.
 */
export function isApproverWorkspace({
  userType,
  isApproverLoggedIn,
  activeWorkspace,
  activeRole,
}) {
  if (activeRole) return ["CMO/CXO", "Approver"].includes(activeRole) && activeWorkspace === "approver" && Boolean(isApproverLoggedIn);
  if (userType === "admin") {
    return activeWorkspace === "approver" && Boolean(isApproverLoggedIn);
  }

  return (
    Boolean(isApproverLoggedIn) ||
    userType === "approver" ||
    userType === "CMO/CXO"
  );
}

export function defaultWorkspace({ userType, isApproverLoggedIn }) {
  if (userType === "admin") return "admin";
  return isApproverWorkspace({ userType, isApproverLoggedIn })
    ? "approver"
    : "user";
}
